import React, { useEffect, useRef, useState } from 'react';
import Button from '../../component/ui/Button';
import { useNavigate, useParams } from 'react-router-dom';
import {
	deletePaymentMade,
	generatePMPdf,
	getPaymentMadeDetails,
} from '../../services/payment_made';
import { getDate } from '../../utils/dateUtils';
import ConfirmationModal from '../../component/modal/ConfirmationModal';
import { toast } from 'react-toastify';
import { numberToWords } from '../../utils/helper';
import PaymentMadeDetailTable from './components/PaymentMadeDetailTable';
import PageLoader from '../../component/PageLoader';
import BillDetailDrawer from '../components/billDetailDrawer';
import { useSelector } from 'react-redux';
import { hasPermission } from '../../utils/controller';

const PaymentMadeDetails = () => {
	const suburl = localStorage.getItem('suburl');
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const param = useParams();
	const id = param?.id;
	const [paymentMadeDetails, setPaymentMadeDetails] = useState({});
	const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
	const [isPBDrawerOpen, setIsPBDrawerOpen] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [pbId, setPbId] = useState('');
	const navigate = useNavigate();
	const printPdfRef = useRef(null);
	const navigateRouter = (path) => {
		navigate(path);
	};
	const [loader, setLoader] = useState(false);

	async function handleConfirmDelete() {
		try {
			await deletePaymentMade([Number(id)]);
			toast.success('payment made deleted successfully');
			navigateRouter(`/user/${suburl}/payment-made`);
		} catch (error) {
			toast.error('Something went wrong!');
		}
	}

	async function handleFetchPaymentMadeDetails() {
		try {
			setIsLoading(true);
			const { payment_made } = await getPaymentMadeDetails(id);
			setPaymentMadeDetails(payment_made);
		} catch (error) {
		} finally {
			setIsLoading(false);
		}
	}

	useEffect(() => {
		if (id) {
			handleFetchPaymentMadeDetails();
		}
	}, [id]);

	async function handlePMPrintAndDownloadPdf(type = 'print') {
		try {
			setLoader(true);
			const pdf_details = await generatePMPdf(id);
			const url = pdf_details.signed_url;

			if (type === 'print') {
				window.open(url, '_blank');
			}

			if (type === 'download') {
				const fileName = `merged_purchase_payment_made_${Date.now()}.pdf`;
				const response = await fetch(url);
				const blob = await response.blob();
				const blobUrl = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = blobUrl;
				link.download = fileName;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				window.URL.revokeObjectURL(blobUrl);
			}
		} catch (err) {
		} finally {
			setLoader(false);
		}
	}

	useEffect(() => {
		if (paymentMadeDetails) {
			document.title = `${paymentMadeDetails?.payment_number} | Payment Made Details | Pharmnex`;
		}
	}, [paymentMadeDetails]);

	return (
		<div style={{ backgroundColor: '#EDEDF7', overflow: 'auto', height: '100%' }}>
			<div className="">
				<div
					className=""
					style={{
						position: 'sticky',
						top: 0,
						zIndex: 100,
					}}
				>
					<div className="product-pg-header add-product">
						<p>Payment Made Detail</p>
						<div className="add-product-button">
							<Button
								type="button"
								className="btn-gray mt-0 px-4"
								disabled={
									!hasPermission('purchases.payment_made.edit', user?.role?.role_permissions)
								}
								button="Edit"
								onClick={() => navigate(`/user/${suburl}/payment-made-create/${id}`)}
							/>
							<Button
								type="button"
								className="btn-gray mt-0 px-4"
								button="Pdf/Print"
								disabled={
									!hasPermission(
										'purchases.payment_made.download_or_print_pdf',
										user?.role?.role_permissions,
									)
								}
								loader={loader}
								onClick={() => handlePMPrintAndDownloadPdf()}
							/>
							<Button
								type="button"
								className="btn-gray mt-0 px-4"
								disabled={
									!hasPermission(
										'purchases.payment_made.communications_email',
										user?.role?.role_permissions,
									)
								}
								button="Send Email"
								onClick={() => navigate(`/user/${suburl}/payment-made-send-emails/${id}`)}
							/>
							<Button
								type="button"
								className="btn-gray mt-0 px-4"
								disabled={
									!hasPermission('purchases.payment_made.delete', user?.role?.role_permissions)
								}
								button="Delete"
								onClick={() => setIsDeleteModalOpen(true)}
							/>
							<Button
								type="button"
								className="mt-0 btn-danger add-pro"
								button=""
								close
								onClick={() => navigateRouter(`/user/${suburl}/payment-made`)}
							/>
						</div>
					</div>
				</div>

				{isLoading ? (
					<PageLoader />
				) : (
					<div ref={printPdfRef}>
						<div
							style={{
								maxWidth: '750px',
								margin: '19px auto',
								minHeight: '600px',
								backgroundColor: '#fff',
								padding: '20px',
								boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
							}}
						>
							{/* Store Details */}
							<div style={{ border: '1px solid #555B67', padding: '12px' }}>
								<div style={{ display: 'flex', justifyContent: 'space-between' }}>
									<div style={{ marginBottom: '20px' }}>
										<h4 style={{ marginBottom: '13px', fontWeight: 'bold', fontSize: '22px' }}>
											{paymentMadeDetails?.organisation?.organisation_name}
										</h4>
										<p style={{ color: '#555B67', fontSize: '14px' }}>
											{paymentMadeDetails?.organisation?.address?.state?.name || 'N/A'}
										</p>
										<p style={{ color: '#555B67', fontSize: '14px' }}>
											{paymentMadeDetails?.organisation?.address?.country?.name || 'N/A'}
										</p>
									</div>
								</div>

								<h5
									style={{
										margin: '8px 262px 28px 280px',
										fontWeight: '600',
										borderBottom: '1px solid black',
										fontSize: '20px',
										textAlign: 'center',
										maxWidth: '148px',
										paddingBottom: '5px',
									}}
								>
									Payment Made
								</h5>
								<div
									style={{
										display: 'flex',
										justifyContent: 'space-between',
										alignItems: 'flex-start',
										marginBottom: '20px',
									}}
								>
									<div>
										<div className="d-flex">
											<div style={{ marginTop: '5px', color: '#555B67' }}>
												<p style={{ marginBottom: '16px' }}>Payment#</p>
												<p style={{ marginBottom: '16px' }}>Payment Date</p>
												<p style={{ marginBottom: '16px' }}>Reference Number</p>
												<p style={{ marginBottom: '16px' }}>Payment Mode</p>
												<p style={{ marginBottom: '16px' }}>Paid Through</p>
												<p style={{ marginBottom: '16px' }}>Amount Paid In Words</p>
											</div>
											<div style={{ width: '270px', marginLeft: '35px', fontWeight: 'bold' }}>
												<p style={{ borderBottom: '1px solid #E5E6E8', marginBottom: '20px' }}>
													{paymentMadeDetails?.payment_number}
												</p>
												<p style={{ borderBottom: '1px solid #E5E6E8', marginBottom: '15px' }}>
													{getDate(paymentMadeDetails?.date)}
												</p>
												<p style={{ borderBottom: '1px solid #E5E6E8', marginBottom: '15px' }}>
													{paymentMadeDetails?.reference_number || 'N/A'}
												</p>
												<p style={{ borderBottom: '1px solid #E5E6E8', marginBottom: '15px' }}>
													{paymentMadeDetails?.payment_mode}
												</p>
												<p style={{ borderBottom: '1px solid #E5E6E8', marginBottom: '15px' }}>
													{paymentMadeDetails?.organisation?.organisation_name}
												</p>
												<p style={{ borderBottom: '1px solid #E5E6E8' }}>
													{numberToWords(Number(paymentMadeDetails?.payment_amount))}
												</p>
											</div>
										</div>
									</div>

									<div
										style={{
											backgroundColor: '#84AD5F',
											width: '170px',
											height: '110px',
											marginTop: '18px',
											color: 'white',
											textAlign: 'center',
										}}
									>
										<div style={{ marginTop: '32px' }}>
											<p style={{ marginRight: '24px' }}> Amount Paid</p>
											<p style={{ fontSize: '20px', fontWeight: '600' }}>
												{'Rs. '}
												{Number(paymentMadeDetails?.payment_amount).toFixed(2)}
											</p>
										</div>
									</div>
								</div>

								{/* Paid To */}
								<div style={{ marginBottom: '20px' }}>
									<p style={{ fontWeight: 'bold', margin: 0 }}>Paid To</p>
									<a
										href="#"
										style={{ color: '#3B58FF', textDecoration: 'none', fontWeight: 'bold' }}
									>
										{paymentMadeDetails?.vendor?.vendor_name}
									</a>
								</div>

								{/* Table */}
								<PaymentMadeDetailTable
									tableColumns={['Bill Number', 'Bill Date', 'Bill Amount', 'Payment Amount']}
									tableRows={paymentMadeDetails.purchase_bill_payment_made}
									setPbId={setPbId}
									setIsPBDrawerOpen={setIsPBDrawerOpen}
									type={'pm'}
								/>
							</div>
						</div>
					</div>
				)}
			</div>
			<ConfirmationModal
				isOpen={isDeleteModalOpen}
				onCancel={() => setIsDeleteModalOpen(false)}
				onOk={handleConfirmDelete}
				title="Confirm Deletion"
				content={
					<p
						style={{
							textAlign: 'center',
							backgroundColor: '#E6F5FF',
							padding: '10px',
							borderRadius: '5px',
							fontWeight: '500',
							color: 'black',
						}}
					>
						Are you sure you want to delete{' '}
						<span style={{ fontWeight: '600' }}>{paymentMadeDetails?.payment_number}</span>?
					</p>
				}
			/>
			{
				<BillDetailDrawer
					isOpen={isPBDrawerOpen}
					onClose={() => setIsPBDrawerOpen(false)}
					id={pbId}
				/>
			}
		</div>
	);
};

export default PaymentMadeDetails;
